import { service } from '../utils/request';

export function accountingPoints() {
  return new Promise((resolve, reject) => {
    service({
      url: '/customer/v1/accountingpointsdisplay',
      method: 'get',
    })
      .then(function (res) {
        if (res.data) {
          res.data.AccountingPoints = [];
          if (
            res.data.Accounts &&
            res.data.Accounts.length &&
            res.data.Accounts.length > 0
          ) {
            res.data.Accounts.forEach((account) => {
              if (
                account &&
                account.AccountingPoints &&
                account.AccountingPoints.length &&
                account.AccountingPoints.length > 0
              ) {
                account.AccountingPoints.forEach((accountingPoint) => {
                  if (!accountingPoint.AccountGuid)
                    accountingPoint.AccountGuid = account.Guid;
                  res.data.AccountingPoints.push(accountingPoint);
                });
              }
            });
          }
        }

        resolve(res);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function getCmsConfig(tenant) {
  let url = localStorage.getItem('api_url');
  return fetch(`${url}/ucconfig/v1/front/B2C/MyPage/${tenant}/Cms.json`);
}

export function products() {
  return service({
    url: '/customer/v1/products',
    method: 'get',
  });
}

export function getProductById(id) {
  return service({
    url: '/weborder/v1/product/' + id,
    method: 'get',
  });
}

export function invoices() {
  return service.get(
    '/customer/v2/invoices?page=-1&size=20&api=b2c&removeCredited=true'
  );
}

export async function invoicePdf(url) {
  let res = await service(url, { responseType: 'blob' });
  console.log(res);
  return res;
}

export function consumption(params) {
  return service({
    url: '/customer/v1/consumptions?' + params,
    method: 'get',
  });
}

export function consumptionCalculation(params) {
  return service({
    url: '/customer/v1/GetCalculation?' + params,
    method: 'get',
  });
}

export function account() {
  return service({
    url: '/customer/v1/accounts',
    method: 'get',
  });
}

export function customer() {
  return service({
    url: '/customer/v1/customer',
    method: 'get',
  });
}

export function editAccount(id, data) {
  return service({
    url: '/customer/v1/account/' + id,
    method: 'patch',
    data,
  });
}

export function editPassword(data) {
  return service.put('/customer/v1/password', data);
}

export function changeContractProduct(id, data) {
  return service({
    url: '/customer/v1/customer/contracts',
    method: 'post',
    data,
  });
}

export function changeContractProductSecondary(ucguid, data) {
  return service({
    url: '/customer/v1/customer/contract/' + ucguid,
    method: 'patch',
    data,
  });
}

export function getPrices(data) {
  return service({
    url:
      '/customer/v2/GetPriceInformation?ap=' +
      data.ap +
      '&customer=' +
      data.customer +
      '&date=' +
      data.date,
    method: 'get',
  });
}
